import { Button } from "@mui/material";
import { type FC } from "react";
import toast from "react-hot-toast";
import { useApiServiceCallback } from "../../../../server/api/client";
import type { UUID } from "../../../../utils/uuid";
import { MomentService } from "../../../moment/client";

export const FollowUpPauseButton: FC<{
  saving: boolean;
  onSaving: () => void;
  onSaved: (success: boolean) => void;
  moment_id: UUID;
  disabled: boolean;
}> = ({ moment_id, saving, onSaving, onSaved, disabled }) => {
  const handlePause = useApiServiceCallback(
    MomentService,
    async ({ apiService }) => {
      onSaving();
      const { error } = await apiService.setActiveStatus(moment_id, false, false);
      if (error) toast.error(error);
      else toast.success("Communication Paused.");

      onSaved(error === undefined);
    },
    [moment_id, onSaved, onSaving],
  );

  if (disabled) return null;

  return (
    <Button
      data-analytics-id="follow-up-pause"
      disabled={disabled}
      loading={saving}
      variant="contained"
      onClick={() => void handlePause().catch(console.error)}
      sx={{ ml: 1 }}
    >
      Pause and Edit
    </Button>
  );
};
